import { Type } from '@angular/core';
import { environment } from '@environments/environments';
import { BraintreeCreditCardDrawerComponent } from '@shared/components/page-layout/drawers/braintree-credit-card-drawer/braintree-credit-card-drawer.component';
import { JpMorganCreditCardDrawerComponent } from '@shared/components/page-layout/drawers/jpmorgan-credit-card-drawer/jpmorgan-credit-card-drawer.component';
import { LayoutDrawerComponent } from '@shared/components/page-layout/drawers/layout-drawer.component';

/**
 * Resolves to whichever credit card gateway drawer is active for this environment
 * (environment.useJpMorganCreditCardDrawer). Kept at this file path/export name so the
 * ~26 call sites across the app that open this drawer or compare against it by class
 * identity don't need to change.
 */
export const CustomCreditCardDrawerComponent: Type<LayoutDrawerComponent> =
    environment.useJpMorganCreditCardDrawer
        ? JpMorganCreditCardDrawerComponent
        : BraintreeCreditCardDrawerComponent;
